import { useAttachmentStoreFactory } from '@widgets/messenger/stores/useAttachmentStoreFactory'

export const useChatEditorAttachmentStore = useAttachmentStoreFactory(Symbol('chatEditorAttachmentStore'))
